var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-bottom-sheet',{attrs:{"width":"500"},model:{value:(_vm.sheet),callback:function ($$v) {_vm.sheet=$$v},expression:"sheet"}},[(_vm.item)?_c('EventSheet',{attrs:{"value":_vm.item},on:{"close":function($event){_vm.sheet = false}}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }